import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './news-carousel.scss';
import OptimizedImage from '../common/OptimizedImage';

/* eslint-disable react/prop-types */

// Default news items if none provided
const defaultNewsItems = [
  {
    title: "Quantum Computing Training Delivered to Leading UK Defence Contractor",
    description: "We have now trained over 350 people on Quantum Computing through our in-person training. This includes sessions in Madrid for a leading space agency, sessions in India for a leading global bank, and recently we trained a team of senior managers for a leading defence contractor.",
    date: "2025-10-28",
    image: "/assets/images/optimized/EdTech/image4",
    linkText: "View Our Quantum Course Outline",
    link: "/course/QUANTUM/Quantum%20Computing%20Fundamentals",
    alt: "Quantum computing training session with technical professionals learning advanced quantum algorithms"
  },
  {
    title: "Generative AI Training Now Available for UK Enterprises",
    description: "Transform your organization with our expert-led GenAI training programs. Tailored courses for defence, finance, and logistics sectors covering AI agents and enterprise implementation.",
    date: "2025-11-05",
    image: "/assets/images/optimized/Training/image3",
    linkText: "View Our Generative AI Course Outline",
    link: "/course/INTRO_AI/Introduction%20to%20Generative%20AI",
    alt: "Enterprise team participating in generative AI training workshop with instructor"
  },

  {
    title: "Microsoft Copilot Training: Agents, AI Automation & Productivity",
    description: "Our Microsoft Copilot courses are helping UK teams cut hours of manual work every week. From creating intelligent Copilot Agents to building advanced AI automations across Microsoft 365, we give your people the skills to work smarter — not harder. Trusted by leading organisations across finance, logistics and defence.",
    date: "2026-01-15",
    image: "/assets/images/optimized/Training/image3",
    linkText: "Explore Microsoft Copilot Training",
    link: "/course/MS_COPILOT_AGENTS/Building%20Microsoft%20Copilot%20Agents",
    alt: "Professional team learning Microsoft Copilot agent building and AI automation in a hands-on training workshop"
  },

  {
    title: "Altova Partnership: Supporting Logistics Sector with FlowForce Server",
    description: "As an official Altova consulting and training partner, we've just added yet another logistics sector client for FlowForce Server consultancy. We deliver specialized XML, data mapping, and enterprise data management solutions across Europe.",
    date: "2025-10-28",
    image: "/assets/images/optimized/Consultancy/image1",
    linkText: "Explore Our Altova Services",
    link: "/altova",
    alt: "Logistics professionals working on data mapping and XML integration with Altova FlowForce Server"
  }
];

const NewsCarousel = ({ newsItems = defaultNewsItems }) => (
  <section className="news-carousel-container" aria-label="Latest News">
    <div className="news-swiper-wrapper">
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        speed={800}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        a11y={{ prevSlideMessage: 'Previous news', nextSlideMessage: 'Next news' }}
      >
        {newsItems.map((item) => (
          <SwiperSlide key={`${item.title}-${item.date}`}>
            <article className="news-card">
              {item.image.startsWith('http') ? (
                <img src={item.image} alt={item.alt || item.title} className="news-image" />
              ) : (
                <OptimizedImage src={item.image} alt={item.alt || item.title} className="news-image" />
              )}
              <div className="news-content">
                <h3 className="news-title">{item.title}</h3>
                {/* <time className="news-date" dateTime={item.date}>{new Date(item.date).toLocaleDateString('en-GB', { month: 'short', day: 'numeric', year: 'numeric' })}</time> */}
                <p className="news-summary">{item.description}</p>
                <a href={item.link} className="news-link" aria-label={`Read more about ${item.title}`}>
                  {item.linkText || 'Read More'}
                </a>
              </div>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </section>
);

export default NewsCarousel;
